import _ from 'lodash'
import Vue from 'vue'

import Logger from '@/logger'

import { initialState } from './state'

const MUTATIONS = {

    resetState: 'reset-state-metrics',

    clearNotApplied: 'clear-not-applied',
    setBase: 'set-base-metrics',
    setLoading: 'set-metrics-loading',
    updateNotApplied: 'update-not-applied',
    updateProjections: 'update-metric-projections',
}

export { MUTATIONS }

export default {

    /**
     * Resets state.
     *
     * @param {Object} state
     */
    [MUTATIONS.resetState](state) {
        for (const item in initialState)
            Vue.set(state, item, _.cloneDeep(initialState[item]))

        Logger.logObject(state, 'State (Metrics) reset')
    },

    /**
     * Resets state.
     *
     * @param {Object} state
     */
    [MUTATIONS.clearNotApplied](state) {
        state.notAppliedImprovements = []
        Logger.logObject(state, `State updated ${ MUTATIONS.clearNotApplied }`, 'Metrics')
    },

    /**
     * Sets the base metric values.
     *
     * @param {Object} state
     * @param {Array} baseValues A selection of base values to apply to each metric value.
     */
    [MUTATIONS.setBase](state, baseValues) {
        if (baseValues) {
            for (let i = 0; i < baseValues.length; i++) {
                const el = baseValues[i]
                const metric = state.data.find(m => m.key == el.key)
                metric.current = el.value
                metric.projected = el.value
            }
            state.loaded = true
            Logger.logObject(state, `State updated ${ MUTATIONS.setBase }`, 'Metrics')
        } else {
            state.loaded = false
            Logger.logObject(state, `State updated ${ MUTATIONS.setBase } - set to null`, 'Metrics')
        }
    },

    /**
     * Sets the flag to indicate metrics are loading.
     *
     * @param {Object} state
     * @param {boolean} [loadingState=true] An optional state to set.
     */
    [MUTATIONS.setLoading](state, loadingState = true) {
        state.loading = loadingState
    },

    /**
     * Resets state.
     *
     * @param {Object} state
     * @param {Array} changes A selection of improvements that were not applied in the latest savings load.
     */
    [MUTATIONS.updateNotApplied](state, notApplied) {
        state.notAppliedImprovements = notApplied
        Logger.logObject(state, `State updated ${ MUTATIONS.updateNotApplied }`, 'Metrics')
    },

    /**
     * Updates metric projections.
     *
     * @param {Object} state
     * @param {Array} changes A selection of changes to apply to each metric value.
     */
    [MUTATIONS.updateProjections](state, changes) {
        state.data.forEach(m => m.projected = m.current)

        if (changes) {
            state.loading = true
            for (let i = 0; i < changes.length; i++) {
                const el = changes[i]
                const metric = state.data.find(m => m.key == el.key)

                if (metric)
                    metric.projected = el.value
            }
        }
        state.loading = false

        Logger.logObject(state, `State updated ${ MUTATIONS.updateProjections }`, 'Metrics')
    },
}
